import React from "react";

export default React.createContext({
  registerTab: () => {},
  deregisterTab: () => {},
  tabWidth: null,
});
